import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text, Title } from '@dropbox/dig-components/typography';
import { Button } from '@dropbox/dig-components/buttons';
import { FailPictogram } from '@dropbox/dig-icons/assets';
import { isString } from 'lodash';

import { messages, postMessage } from 'signer-app/utils/post-message';
import { declineCompleteIntl } from 'signer-app/pages/decline-complete/decline-complete.intl';
import styles from 'signer-app/pages/decline-complete/decline-complete.module.css';
import { WebsiteLayout } from 'signer-app/parts/website-layout';
import { PictogramIcon } from '@dropbox/dig-icons';
import { Box } from '@dropbox/dig-foundations';

type Props = {
  isEmbedded: boolean;
  parentUrl?: string;
};

export default function SignerDeclineComplete({
  isEmbedded,
  parentUrl,
}: Props): JSX.Element {
  const closeIFrame = useCallback(() => {
    if (isEmbedded && isString(parentUrl)) {
      postMessage(
        {
          type: messages.USER_FINISH_REQUEST,
        },
        parentUrl,
      );
    }
  }, [isEmbedded, parentUrl]);

  return (
    <WebsiteLayout isEmbedded={isEmbedded}>
      <Box className={styles.container}>
        <Box className={styles.content} backgroundColor="Background Base">
          <PictogramIcon src={FailPictogram} />
          <Title>
            <FormattedMessage {...declineCompleteIntl.h1} />
          </Title>
          <Text tagName="h2">
            <FormattedMessage {...declineCompleteIntl.h2} />
          </Text>
          {isEmbedded && (
            <Button
              className={styles.iframeClose}
              onClick={closeIFrame}
              variant="primary"
            >
              <FormattedMessage {...declineCompleteIntl.close} />
            </Button>
          )}
        </Box>
      </Box>
    </WebsiteLayout>
  );
}
